/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_CurrencyInputs */

const cs_filter_currency = /** @type {(inputs: Filter_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Měna`)
};

const en_filter_currency = /** @type {(inputs: Filter_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currency`)
};

/**
* | output |
* | --- |
* | "Currency" |
*
* @param {Filter_CurrencyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_currency = /** @type {((inputs?: Filter_CurrencyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_CurrencyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_currency(inputs)
	return cs_filter_currency(inputs)
});